<template>
<div>
    <ob-modal2 :show.sync="show" width="900px" :backdrop="false" id="scrollable-container5">
        <template slot="modal-title">
            <div class="modal-head">
                <h4 class="modal-title" v-if="_IsUpadet">
                       Update Student Evaluation 
                </h4>
                <h4 class="modal-title" v-else-if="_IsInitiate">
                      Initiate Student Evaluation
                </h4>
                <h4 class="modal-title" v-else-if="_IsVerify">
                      Verify Student Evaluation
                </h4>
                <h4 class="modal-title" v-else-if="_IsComplete">
                      Complete Student Evaluation
                </h4>
            </div>
        </template>

        <template slot="modal-body">

            <div class="row rowgap">
                    <div class="col-md-2">
                        <div class="form-group">
                            <label>Student Name</label>
                              <p class="preview-details">
                                 <b v-if="StudentDetails.Name != null && StudentDetails.Name != ''">{{StudentDetails.Name}}</b>
                                 <b v-else>N/A</b>
                             </p>
                        </div>
                    </div>
                     <div class="col-md-3">
                        <div class="form-group">
                            <label>Student Email Address</label>
                             <p class="preview-details">
                                 <b v-if="StudentDetails.Name != null && StudentDetails.EmailAddress != ''">{{StudentDetails.EmailAddress}}</b>
                                 <b v-else>N/A</b>
                             </p>
                        </div>
                    </div>
                     
            </div>
              
                <div class="row rowgap">
                    <div class="col-md-4">
                        <div class="form-group">
                             <label>Range of Evaluation Date(From)</label><span class="validation-star">*</span>
                            <ob-date-time-picker ref="dateFrom" id="dateFrom" :inputvalue="StudentDetails.RangeOfEvaluationDateFrom" :options="options4" @updated="(v) => this.StudentDetails.RangeOfEvaluationDateFrom = v" :dpchange="onFromDateChange"  :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.RangeOfEvaluationDateFrom.$error }"></ob-date-time-picker>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.RangeOfEvaluationDateFrom.$dirty && !$v.StudentDetails.RangeOfEvaluationDateFrom.required">Enter Range Of Evaluation Date From</span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                             <label>Range of Evaluation Date(To)</label><span class="validation-star">*</span>
                          <ob-date-time-picker ref="dateTo" id="dateTo" :inputvalue="StudentDetails.RangeOfEvaluationDateTo"  :options="options4" @updated="(v) => this.StudentDetails.RangeOfEvaluationDateTo = v"  :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.RangeOfEvaluationDateTo.$error }"></ob-date-time-picker>
                           <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.RangeOfEvaluationDateTo.$dirty && !$v.StudentDetails.RangeOfEvaluationDateTo.required"> Enter Range Of Evaluation Date To</span>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="this.isupdate == false && !this.triggerupdateapi">
                    <div class="col-md-12">
                        <label>Which signature option do you prefer for Form I-983?</label>
                    </div>
                    <div class="col-md-12 " style="margin-bottom: 10px;">
                        <div class="radio-inline">
                            <ob-radio name="electronicSign" :val="1" v-model="SignatureType">Electronic signature</ob-radio>
                            <span style="font-size: 12px; padding-left: 20px;">Electronically fill out and sign the form within the system.</span>
                        </div>
                    </div>
                    <div class="col-md-12" >
                        <div class="radio-inline">
                            <ob-radio name="electronicSign" :val="2" v-model="SignatureType">Ink signature</ob-radio>
                            <span style="font-size: 12px; padding-left: 20px;">Electronically fill out the form, download it, physically sign it with ink, and then upload the signed document into the system.</span>
                        </div>
                    </div>
                    <!-- <div class="modal-body"> -->
                        <span class="ob-vuelidate_error-msg "  style="margin-left: 3em;" v-if="$v.SignatureType.$dirty && !$v.SignatureType.requiredIf">Please select signature preference.</span>
                    <!-- </div> -->
                </div>
                <div class="row" v-if="showEvalutionSummery">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Evaluation Summary</label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '1'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '1' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter your full name (Surname/Primary Name, Given Name) exactly as it appears on your SEVIS (Student and Exchange Visitor Information System) issued Form I‐20, “Certificate of Eligibility for Nonimmigrant (F‐1) Student Status – For Academic and Language Students."'/></span>
                            <ob-textarea :maxLength="1200" v-model="StudentDetails.EvaluationSummary" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.EvaluationSummary.$error }"></ob-textarea>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.EvaluationSummary.$dirty && !$v.StudentDetails.EvaluationSummary.requiredIf">Enter Evaluation Summary</span>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="(previousData.SignatureType == 'Electronic' && !_IsInitiate && ifSupervisor && IsSameEvaluationHRAndSignatoryAuthority)">
                    <div class="form-label" style="max-width:50%; padding-left: 15px;">
                        <label class="label_title">
                            Signature of Employer Official with Signatory Authority <span class="validation-star">*</span>
                        </label>
                            <ob-signature-pad v-if="SupervisorSignatureDetails.EnableSignature"  @scrollToTop="scrollToTop" :istrainingpopup="true" @SaveSignature="SupervisorsaveSignature" style="margin-top: 30px; padding-left: 0; text-align: left; width: 0px;"></ob-signature-pad>
                            <div v-else class="full-width" style="padding-left:0;display: flex;">
                                <div class="custom-sign-div custom-sign-div_inline_style1">
                                    <img :src="SupervisorSignatureDetails.SignatureURL" :class="{'sign-width': this.SupervisorSignatureDetails.isDraw, 'add-sign-width': !this.SupervisorSignatureDetails.isDraw}" alt="Uploaded Signature Url" width="250px" height="100px" style="margin-left: -20px;object-fit: contain;">
                                </div>
                                <div class="custom-sign-div_inline_style2" style="margin-left: 8px;">
                                    <img @click="supervisorEditSignatureMethod(SupervisorSignatureDetails.image, true)" :src="`${CDNIMAGESBASEURL}/web/Content/Images/ic_edit.svg`" alt="edit" class="edit-sign-icon"><br />
                                    <img @click="SupervisorDeleteSiganture(SupervisorSignatureDetails.image)" :src="`${CDNIMAGESBASEURL}/web/Content/Images/ic_delete.svg`" alt="delete" class="delete-sign-icon">
                                </div>
                                <ob-edit-signature-pad @SaveSignatureEdit="SupervisorSignatureEdit" :editSignature.sync="SupervisorSignatureDetails.editUpload" :fileName="'StudentSign'" :tabType="SupervisorSignatureDetails.tabType" :data="SupervisorSignatureDetails.uploadData" :drawImageProp="SupervisorSignatureDetails.drawImage" :isDraw="SupervisorSignatureDetails.isDraw" :metaInformation="SupervisorSignatureDetails.metaInformation" @scrollToTop="scrollToTop" :istrainingpopup="true"></ob-edit-signature-pad>
                            </div>
                    </div>
                </div>
                <div class="row" v-else-if="!_IsInitiate && SupervisorSignatureDetails.SignatureURL != null && SupervisorSignatureDetails.SignatureURL != ''">
                    <div class="form-label" style="max-width:50%; padding-left: 15px;">
                        <label class="label_title">
                            Signature of Employer Official with Signatory Authority
                        </label>
                            <div class="full-width" style="padding-left:0;display: flex;">
                                <div class="custom-sign-div custom-sign-div_inline_style1">
                                    <img :src="SupervisorSignatureDetails.SignatureURL" :class="{'sign-width': this.SupervisorSignatureDetails.isDraw, 'add-sign-width': !this.SupervisorSignatureDetails.isDraw}" alt="Uploaded Signature Url" width="250px" height="100px" style="margin-left: -20px;object-fit: contain;">
                                </div>
                            </div>
                    </div>
                </div>
                <div class="col-md-12 pL0" v-if="(previousData.SignatureType == 'Electronic' && !_IsInitiate && ifSupervisor)" style="margin-top:10px" >
                    <span class="ob-vuelidate_error-msg" v-if="$v.SupervisorSignatureDetails.Base64Url.$dirty && !$v.SupervisorSignatureDetails.Base64Url.requiredIf">Please enter signature</span>
                </div>
                
                <div class="row" v-if="(previousData.SignatureType == 'Electronic' && !_IsInitiate && !ifSupervisor)">
                    <div class="form-label" style="max-width:50%; padding-left: 15px;">
                        <label class="label_title">
                            Signature of Employee  <span class="validation-star">*</span>
                            <!-- <i class="fa fa-info-circle info-icon" @click="signaturetoggleCollapse('EnableSignature')" title=" Enable Signature - Click for more information"></i> -->
                        </label>
                            <ob-signature-pad v-if="SignatureDetails.EnableSignature"  @scrollToTop="scrollToTop" :istrainingpopup="true" @SaveSignature="saveSignature" style="margin-top: 30px; padding-left: 0; text-align: left; width: 0px;"></ob-signature-pad>
                        <div v-else class="full-width" style="padding-left:0;display: flex;">
                            <div class="custom-sign-div custom-sign-div_inline_style1">
                                <img :src="SignatureDetails.SignatureURL" :class="{'sign-width': this.SignatureDetails.isDraw, 'add-sign-width': !this.SignatureDetails.isDraw}" alt="Uploaded Signature Url" width="250px" height="100px" style="margin-left: -20px;object-fit: contain;">
                            </div>
                            <div class="custom-sign-div_inline_style2" style="margin-left: 8px;">
                                <img @click="editSignatureMethod(SignatureDetails.image, true)" :src="`${CDNIMAGESBASEURL}/web/Content/Images/ic_edit.svg`" alt="edit" class="edit-sign-icon"><br />
                                <img @click="deleteSiganture(SignatureDetails.image)" :src="`${CDNIMAGESBASEURL}/web/Content/Images/ic_delete.svg`" alt="delete" class="delete-sign-icon">
                            </div>
                            <!-- <div v-if="openEditsignature"> -->
                            <ob-edit-signature-pad @SaveSignatureEdit="SignatureEdit" :editSignature.sync="SignatureDetails.editUpload" :fileName="'StudentSign'" :tabType="SignatureDetails.tabType" :data="SignatureDetails.uploadData" :drawImageProp="SignatureDetails.drawImage" :isDraw="SignatureDetails.isDraw" :metaInformation="SignatureDetails.metaInformation" @scrollToTop="scrollToTop" :istrainingpopup="true"></ob-edit-signature-pad>
                            <!-- </div> -->
                        </div>
                    </div>
                </div>
                <div class="row" v-else-if="SignatureDetails.SignatureURL != null && SignatureDetails.SignatureURL != '' && !_IsInitiate">
                    <div class="form-label" style="max-width:50%; padding-left: 15px;">
                        <label class="label_title">
                            Signature of Employee 
                        </label>
                        <div  class="full-width" style="padding-left:0;display: flex;">
                            <div class="custom-sign-div custom-sign-div_inline_style1">
                                <img :src="SignatureDetails.SignatureURL" :class="{'sign-width': this.SignatureDetails.isDraw, 'add-sign-width': !this.SignatureDetails.isDraw}" alt="Uploaded Signature Url" width="250px" height="100px" style="margin-left: -20px;object-fit: contain;">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <span class="ob-vuelidate_error-msg" style="margin-bottom: 5px;" v-if="$v.SignatureDetails.Base64Url.$dirty && !$v.SignatureDetails.Base64Url.requiredIf">Please enter signature</span>
                </div>

                 <div class="row rowgap" style="padding-left:15px">
                    <div class="checkbox-inline" style="padding: 0; margin-right: 5px;"><ob-checkbox :disabled="disableFinalEvaluationCheckbox" v-model="StudentDetails.isFinalEvalution">This is the Final Evaluation</ob-checkbox></div><i style="vertical-align: middle;" class="fa fa-info-circle" v-if="disableFinalEvaluationCheckbox" v-tooltip="'Final Evaluation is already done. Please update the current final evaluation to enable this checkbox.'"></i>
                </div>

                <div class="row rowgap" style="padding-left:15px" v-if="isHRManager">
                   An Email will be sent to the student with the above information.
                </div>
                <div class="row rowgap" style="padding-left:15px" v-else>
                   An Email will be sent to the HR Manager with the above information.
                </div>
                <div v-if="!isupdate && !triggerupdateapi && show" class="row rowgap"  style="border-top: 1.5px dashed #d4cccc;margin-top: 15px; padding-top: 15px;">
                    <b class="col-md-12" style="padding-bottom:15px">Choose your preferred option to initiate Student Evaluation<span class="validation-star">*</span></b>
                    
                    <div class="col-md-6">
                        <ob-radio name="I983FormType"  :val="true" v-model="IsInitiateOnlySectionType"><b>Initiate Student Evaluation Only</b></ob-radio>
                        <p style="padding-left: 20px;">Creates only Student Evaluation section</p>
                    </div>
                    <div class="col-md-6">
                        <ob-radio name="I983FormType"  :val="false" v-model="IsInitiateOnlySectionType"><b>Initiate New Form I-983</b></ob-radio>
                        <p style="padding-left: 20px;">Creates a new Form I-983 by auto-populating all the data from the existing one.</p>
                    </div>
                </div>

          <!-- intiate new form i983  dropdown -->
                <div v-if="_IsInitiate">
                    <h3 style="font-weight: 600; color: #000;padding:inherit;">Who Should review and sign the Student Evalution Section ?</h3>
                    <div class="row " style="margin-top: 5px !important;">
                        <div class="col-md-5">
                            <div class="form-group">                           
                                <label>Employer Official with Signatory Authority</label> <span class="validation-star">*</span><i class="fa fa-info-circle" v-tooltip="'You can Select from Signatory Authorities,HR Managers, or Supervisors.'"></i>
                                <ob-select2 v-if="showSignatoryauthorityList" :disabled="isSupervisor == false" :inModal="true" :options="signatoryauthorityList" v-model.trim="selectedEvaluationSignatoryAuthorityEmail"  :class="{ 'ob-vuelidate_input-error': $v.selectedEvaluationSignatoryAuthorityEmail.$error }"></ob-select2>
                                <span style="display: block;" v-else>Loading....</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.selectedEvaluationSignatoryAuthorityEmail.$dirty && !$v.selectedEvaluationSignatoryAuthorityEmail.required">Enter Employer Official with Signatory Authority </span>
                            </div>
                        </div> 
                    </div>
                    <div class="row rowgap" >
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Name of Official</label><span class="validation-star">*</span>
                                <ob-input :disabled="true" v-formi9-name v-model.trim="Evaluation.SignatoryAuthority.Name" placeholder="Enter Name of Official" :class="{ 'ob-vuelidate_input-error': $v.Evaluation.SignatoryAuthority.Name.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Evaluation.SignatoryAuthority.Name.$dirty && !$v.Evaluation.SignatoryAuthority.Name.required">Enter Name of Official</span>
                                <!-- <span class="ob-vuelidate_error-msg" v-if="$v.Evaluation.SignatoryAuthority.Name.$dirty && !$v.Evaluation.SignatoryAuthority.Name.alphawithspace">Enter alphabets only</span> -->
                                <span class="ob-vuelidate_error-msg" v-if="$v.Evaluation.SignatoryAuthority.Name.$dirty && !$v.Evaluation.SignatoryAuthority.Name.maxLength && $v.Evaluation.SignatoryAuthority.Name.alpha">Enter 150 characters only</span> 
                                <span class="ob-vuelidate_error-msg" v-if="$v.Evaluation.SignatoryAuthority.Name.$dirty &&  $v.Evaluation.SignatoryAuthority.Name.alpha && !$v.Evaluation.SignatoryAuthority.Name.letterCount">Each word can have a maximum of 100 characters only.</span>
                            </div> 
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Official's Title</label><span class="validation-star">*</span>
                                <ob-input :disabled="true" v-model.trim="Evaluation.SignatoryAuthority.Title" placeholder="Enter Official's Title" :class="{ 'ob-vuelidate_input-error': $v.Evaluation.SignatoryAuthority.Title.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Evaluation.SignatoryAuthority.Title.$dirty && !$v.Evaluation.SignatoryAuthority.Title.required">Enter Official's Title</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Evaluation.SignatoryAuthority.Title.$dirty && !$v.Evaluation.SignatoryAuthority.Title.maxLength && $v.Evaluation.SignatoryAuthority.Title.alpha">Enter 150 characters only</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Evaluation.SignatoryAuthority.Title.$dirty &&  $v.Evaluation.SignatoryAuthority.Title.alpha && !$v.Evaluation.SignatoryAuthority.Title.letterCount">Each word can have a maximum of 100 characters only.</span>
                            </div>
                        </div> 
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Official's Email</label><span class="validation-star">*</span>
                                <ob-input :disabled="true" v-model.trim="Evaluation.SignatoryAuthority.Email" placeholder="Enter Official's Email"  :class="{ 'ob-vuelidate_input-error': $v.Evaluation.SignatoryAuthority.Email.$error }" ></ob-input>
                                <template v-if="$v.Evaluation.SignatoryAuthority.Email.$dirty">
                                    <span class="ob-vuelidate_error-msg" v-if="!$v.Evaluation.SignatoryAuthority.Email.required">Enter Official's Email</span>
                                    <span class="ob-vuelidate_error-msg" v-else-if="!$v.Evaluation.SignatoryAuthority.Email.email">Enter valid email</span>
                                </template>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Official's Phone Number</label><span class="validation-star">*</span>
                                <ob-input  v-model.trim="Evaluation.SignatoryAuthority.Phone" placeholder="Enter Official's Phone Number"  :class="{ 'ob-vuelidate_input-error': $v.Evaluation.SignatoryAuthority.Phone.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Evaluation.SignatoryAuthority.Phone.$dirty && !$v.Evaluation.SignatoryAuthority.Phone.required">Enter Phone Number</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Evaluation.SignatoryAuthority.Phone.$dirty && !$v.Evaluation.SignatoryAuthority.Phone.phoneNumber && $v.Evaluation.SignatoryAuthority.Phone.required">Enter valid Phone Number</span>
                                 <span class="ob-vuelidate_error-msg" v-if="$v.Evaluation.SignatoryAuthority.Phone.$dirty && !$v.Evaluation.SignatoryAuthority.Phone.maxLength && $v.Evaluation.SignatoryAuthority.Phone.phoneNumber">Enter valid Phone Number</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Evaluation.SignatoryAuthority.Phone.$dirty && !$v.Evaluation.SignatoryAuthority.Phone.minLength && $v.Evaluation.SignatoryAuthority.Phone.phoneNumber">Enter valid Phone Number</span> 
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if ="!IsInitiateOnlySectionType && _IsInitiate ">
                    <h3 style="font-weight: 600; color: #000;padding:inherit;">Who Should review and sign the Employer Information(Section 3 & 4)?</h3>
                    <div class="row " style="margin-top: 5px !important;">
                        <div class="col-md-5">
                            <div class="form-group">                           
                                <label>Employer Official with Signatory Authority</label> <span class="validation-star">*</span><i class="fa fa-info-circle" v-tooltip="'You can Select from Signatory Authorities,HR Managers, or Supervisors.'"></i>
                                <ob-select2 v-if="showSignatoryauthorityList"  :disabled="isSupervisor == false" :inModal="true" :options="signatoryauthorityList" v-model.trim="selectedEmployerSignatoryAuthorityEmail"  :class="{ 'ob-vuelidate_input-error': $v.selectedEmployerSignatoryAuthorityEmail.$error }"></ob-select2>
                                <span style="display: block;" v-else>Loading....</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.selectedEmployerSignatoryAuthorityEmail.$dirty && !$v.selectedEmployerSignatoryAuthorityEmail.requiredIf">Enter Employer Official with Signatory Authority</span>
                            </div>
                        </div> 
                    </div>
                    <div class="row rowgap" >
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Name of Official</label><span class="validation-star">*</span>
                                <ob-input :disabled="true" v-formi9-name v-model.trim="Employer.SignatoryAuthority.Name" placeholder="Enter Name of Official"  :class="{ 'ob-vuelidate_input-error': $v.Employer.SignatoryAuthority.Name.$error }" ></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Name.$dirty && !$v.Employer.SignatoryAuthority.Name.requiredIf">Enter Name of Official</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Name.$dirty && !$v.Employer.SignatoryAuthority.Name.maxLength && $v.Employer.SignatoryAuthority.Name.alpha">Enter 150 characters only</span> 
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Name.$dirty &&  $v.Employer.SignatoryAuthority.Name.alpha && !$v.Employer.SignatoryAuthority.Name.letterCount">Each word can have a maximum of 100 characters only.</span>
                            </div> 
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Official's Title</label><span class="validation-star">*</span>
                                <ob-input :disabled="true" v-model.trim="Employer.SignatoryAuthority.Title" placeholder="Enter Official's Title"  :class="{ 'ob-vuelidate_input-error': $v.Employer.SignatoryAuthority.Title.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Title.$dirty && !$v.Employer.SignatoryAuthority.Title.requiredIf">Enter Official's Title</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Title.$dirty && !$v.Employer.SignatoryAuthority.Title.maxLength && $v.Employer.SignatoryAuthority.Title.alpha">Enter 150 characters only</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Title.alpha && !$v.Employer.SignatoryAuthority.Title.letterCount">Each word can have a maximum of 100 characters only.</span>
                            </div>
                        </div> 
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Official's Email</label><span class="validation-star">*</span>
                                <ob-input :disabled="true" v-model.trim="Employer.SignatoryAuthority.Email" placeholder="Enter Official's Email" :class="{ 'ob-vuelidate_input-error': $v.Employer.SignatoryAuthority.Email.$error }"></ob-input>
                                <template v-if="$v.Employer.SignatoryAuthority.Email.$dirty">
                                    <span class="ob-vuelidate_error-msg" v-if="!$v.Employer.SignatoryAuthority.Email.requiredIf">Enter Official's Email</span>
                                    <span class="ob-vuelidate_error-msg" v-else-if="!$v.Employer.SignatoryAuthority.Email.email">Enter valid email</span>
                                </template>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Official's Phone Number</label><span class="validation-star">*</span>
                                <ob-input  v-model.trim="Employer.SignatoryAuthority.Phone" placeholder="Enter Official's Phone Number"  :class="{ 'ob-vuelidate_input-error': $v.Employer.SignatoryAuthority.Phone.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Phone.$dirty && !$v.Employer.SignatoryAuthority.Phone.requiredIf">Enter Phone Number</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Phone.$dirty && !$v.Employer.SignatoryAuthority.Phone.phoneNumber && $v.Employer.SignatoryAuthority.Phone.requiredIf">Enter valid Phone Number</span>
                                 <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Phone.$dirty && !$v.Employer.SignatoryAuthority.Phone.maxLength && $v.Employer.SignatoryAuthority.Phone.phoneNumber">Enter valid Phone Number</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Phone.$dirty && !$v.Employer.SignatoryAuthority.Phone.minLength && $v.Employer.SignatoryAuthority.Phone.phoneNumber">Enter valid Phone Number</span> 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row rowgap"  v-if ="!IsInitiateOnlySectionType && _IsInitiate">
                    <div class="row">
                      <div class="col-md-12">
                        <h3 style="font-weight: 600; color: #000;padding:inherit">Who Should review and sign the Training Plan For STEM OPT students(5& 6)?</h3>
                      </div>
                    </div>
                    <div class="col-md-5">
                        <div class="form-group">
                            <label>Employer Official with Signatory Authority</label> <span class="validation-star">*</span><i class="fa fa-info-circle" v-tooltip="'You can Select from Signatory Authorities,HR Managers, or Supervisors.'"></i>
                            <ob-select2 :disabled="isSupervisor == false" :inModal="true" v-if="showSignatoryauthorityList"  :options="signatoryauthorityList" v-model.trim="selectedTrainingPlanSignatoryAuthorityEmail"  :class="{ 'ob-vuelidate_input-error': $v.selectedTrainingPlanSignatoryAuthorityEmail.$error }" ></ob-select2>
                            <span style="display: block;" v-else>Loading....</span>
                            <span class="ob-vuelidate_error-msg" v-if="$v.selectedTrainingPlanSignatoryAuthorityEmail.$dirty && !$v.selectedTrainingPlanSignatoryAuthorityEmail.requiredIf">Enter Employer Official with Signatory Authority</span>
                        </div>
                    </div>
                    <div class="col-md-12 pL0 pR0">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Name of Official</label><span class="validation-star">*</span>
                                <ob-input :disabled="true" v-formi9-name v-model.trim="AssignedTraining.SignatoryAuthority.Name" placeholder="Enter Name of Official"  :class="{'ob-vuelidate_input-error': $v.AssignedTraining.SignatoryAuthority.Name.$error}"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty && !$v.AssignedTraining.SignatoryAuthority.Name.requiredIf">Enter Name of Official</span>
                                <!-- <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty && !$v.AssignedTraining.SignatoryAuthority.Name.alphawithspace">Enter alphabets only</span> -->
                                <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty && !$v.AssignedTraining.SignatoryAuthority.Name.maxLength && $v.AssignedTraining.SignatoryAuthority.Name.alpha">Enter 150 characters only</span> 
                                <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty &&  $v.AssignedTraining.SignatoryAuthority.Name.alpha && !$v.AssignedTraining.SignatoryAuthority.Name.letterCount">Each word can have a maximum of 100 characters only.</span>
                            </div> 
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Official's Title</label><span class="validation-star">*</span>
                                <ob-input :disabled="true" v-model.trim="AssignedTraining.SignatoryAuthority.Title" placeholder="Enter Official's Title"  :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SignatoryAuthority.Title.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Title.$dirty && !$v.AssignedTraining.SignatoryAuthority.Title.requiredIf">Enter Official's Title</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Title.$dirty && !$v.AssignedTraining.SignatoryAuthority.Title.maxLength && $v.AssignedTraining.SignatoryAuthority.Title.alpha">Enter 150 characters only</span> 
                                <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Title.$dirty &&  $v.AssignedTraining.SignatoryAuthority.Title.alpha && !$v.AssignedTraining.SignatoryAuthority.Title.letterCount">Each word can have a maximum of 100 characters only.</span> 
                            </div>
                        </div> 
                        <div class="col-md-3 ">
                                <div class="form-group">
                                    <label>Official's Email</label><span class="validation-star">*</span>
                                    <ob-input :disabled="true" v-model.trim="AssignedTraining.SignatoryAuthority.Email" placeholder="Enter Official's Email"  :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SignatoryAuthority.Email.$error }"></ob-input>
                                    <template v-if="$v.AssignedTraining.SignatoryAuthority.Email.$dirty">
                                        <span class="ob-vuelidate_error-msg" v-if="!$v.AssignedTraining.SignatoryAuthority.Email.requiredIf">Enter Official's Email</span>
                                        <span class="ob-vuelidate_error-msg" v-else-if="!$v.AssignedTraining.SignatoryAuthority.Email.email">Enter valid email</span>
                                    </template>
                                </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Official's Phone Number</label><span class="validation-star">*</span>
                                <ob-input v-phone-number v-model.trim="AssignedTraining.SignatoryAuthority.Phone" placeholder="Enter Official's Phone Number"  :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SignatoryAuthority.Phone.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Phone.$dirty && !$v.AssignedTraining.SignatoryAuthority.Phone.requiredIf">Enter Phone Number</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Phone.$dirty && !$v.AssignedTraining.SignatoryAuthority.Phone.phoneNumber && $v.AssignedTraining.SignatoryAuthority.Phone.requiredIf">Enter valid Phone Number</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Phone.$dirty && !$v.AssignedTraining.SignatoryAuthority.Phone.maxLength && $v.AssignedTraining.SignatoryAuthority.Phone.phoneNumber">Enter valid Phone Number</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Phone.$dirty && !$v.AssignedTraining.SignatoryAuthority.Phone.minLength && $v.AssignedTraining.SignatoryAuthority.Phone.phoneNumber">Enter valid Phone Number</span> 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="note mt-3" v-if ="!IsInitiateOnlySectionType && _IsInitiate">
                    <p class="text-info">
                    Note: An email will be sent to <strong>{{Evaluation.SignatoryAuthority.Email }}</strong> to review and sign Sections 5 & 6 once the employee reviews the training plan.
                    </p>
                </div>
        </template>

        <template slot="modal-footer" class="modal-footer">
             <ob-button type="secondary" @click="handleCancel">Cancel</ob-button>
             <ob-button v-if="_IsVerify" type="primary"  @click="onInitiateClick">Verify and Save</ob-button>
                <ob-button type="primary" v-else-if="SignatureType == 1" @click="showElectronicsign">Initiate</ob-button>
             <ob-button v-else type="primary"  @click="onInitiateClick">{{ isupdate ? 'Update' : triggerupdateapi ? 'Preview Form' : 'Initiate' }}</ob-button>
        </template>
    </ob-modal2>
        <div v-if="showElectronicSignPopUp">
            <electronic-sign-warning-pop-up :openModalWarning.sync = "showElectronicSignPopUp" :ConsentAvailable.sync = "consentAvailable" :ProceedtoInitiate.sync = "proceedtoInitiate" ></electronic-sign-warning-pop-up>
        </div>
    </div>
</template>
<script>
import c from 'Vue/Core/constants.js'
import WarningPopUp from "Vue/ESSProfile/FormI983/ElectronicSignWarningPopUp.vue"
import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators'
    import { req, withParams } from 'vuelidate/lib/validators/common'
      const DecimalNumber = withParams({ type: 'DecimalNumber' }, value => {
        return !req(value) || /^\d+(\.\d{1,2})?$/.test(value);
    })
     const alphawithspace = (value) => {
     var alsp = /^[a-zA-Z\s]*$/i
     return alsp.test(value)
   };
   const phoneNumber = (param) =>
    withParams(
        { type: 'phoneNumber', value: param},
        (value) => { 
            if(param && (param.indexOf("ChangeInEmployerSite") > -1)  || param.indexOf("Others") > -1) {
               if(value.length > 9 && value.length < 21)
               {
                var phone = /^[0-9 +()-]+$/i
                return phone.test(value)
               }
               else
               {
                 return false
               }
            } else {
                return true;
            }
        }
    );
    const letterCount = withParams({ type: 'letterCount' }, value => {
        if (value !=null && value.length <= 150) {
            var strArr = value.split(" ");
            let error = true;
            strArr.forEach(function (word) {
                if (word.length > 100) {
                    error = false
                    return;
                }
            });
            return !req(value) || error
        }
        else {
            return true
        }

    })


    export default {
        props: ["openModal", "previousData", "isupdate", "triggerupdateapi","isSupervisor"],
        components: {
            "electronic-sign-warning-pop-up": WarningPopUp
        },
        data(){
            return {
                showSignatoryauthorityList:false,
                selectedEvaluationSignatoryAuthorityEmail:'',
                selectedEmployerSignatoryAuthorityEmail:'',
                selectedTrainingPlanSignatoryAuthorityEmail: '',
                IsInitiateOnlySectionType:true,
                disableFinalEvaluationCheckbox: false,
                location: {},
                SignatureType: '',
                GeoLocation: '',
               
                SignatureDetails:{
                        SignedDate: moment(new Date()).format("MM/DD/YYYY"),
                        SignatureURL: '',
                        EnableSignature : true,
                        IsNewSignature : true,
                        IsAllowEdit: true,
                        uploadData : "",
                        image : "",
                        tabType : "",
                        drawImage : "",
                        editUpload: false,
                        isDraw: false,
                        Base64Url:'',
                        metaInformation: {}
                    },
                SupervisorSignatureDetails:{
                        SignedDate: moment(new Date()).format("MM/DD/YYYY"),
                        SignatureURL: '',
                        EnableSignature : true,
                        IsNewSignature : true,
                        IsAllowEdit: true,
                        uploadData : "",
                        image : "",
                        tabType : "",
                        drawImage : "",
                        editUpload: false,
                        isDraw: false,
                        Base64Url:'',
                        metaInformation: {}
                    },
                show: false,
                EvalutionObj:'',
                mouseOver:'',
                EmployerDetails:
                {
                    Signatoryauthority : {
                        Name: '',
                        Email:'',
                        Title: '',
                         Phone:'',
                         Role:''
                    },
                },
                
                Signatoryauthority : {
                    Name: '',
                    Email:'',
                    Title:''
                },
                Evaluation:{
                    EmployeeId:'',
                    SignatoryAuthority:{
                    SiteName: '',
                    SiteAddress: '',
                    Name: '',
                    Title: '',
                    Email: '',
                    Phone: '',
                    Role:''
                    }
                },
                Employer:{
                    SignatoryAuthority:{
                    Name: '',
                    Title: '',
                    Email: '',
                    Phone: '',
                    Role:''
                    } 
                },
                AssignedTraining:{
                    SignatoryAuthority:{
                    Name: '',
                    Title: '',
                    Email: '',
                    Phone: '',
                    Role:''
                    }
                },
               StudentDetails:
               {
                
                 EmployeeId:'',
                  Name:'',
                  EmailAddress:'',
                  
                  RangeOfEvaluationDateFrom:'',
                  RangeOfEvaluationDateTo:'',
                  isFinalEvalution:'',
                  EvaluationSummary: '',
                  Email:'',
                  Title: '',
                  SignatoryAuthority: {
                    SiteName: '',
                    SiteAddress: '',
                    
               },
               },
               options4: {
                         format: 'MM/DD/YYYY',
                         dayViewHeaderFormat: 'MM/DD/YYYY',
                        ignoreReadonly:true,
                        widgetPositioning: {
                            horizontal: "auto",
                            vertical: "bottom"
                        }
                },
                signatoryauthorityList: {
                    placeholder: {
                        id: "-1",
                        text: "Select Signatory Authority"
                    },
                    data: []
                },
                showElectronicSignPopUp : false,
                proceedtoInitiate: false,
                consentAvailable: false,
            }
        },
        watch: {
            openModal(val) {
                
                this.show = val;
                  if(val) { // On Modal Open
                    if(this.previousData.SignatureType == 'Electronic') {

                        // this.getLocation()
                    }

                    this.copyFromStore();
                }
            },
            show(val) {
                this.$emit('update:openModal', val)
                if(val)
                {
                    this.getSignatoryauthorityList();
                }
            },
            selectedEvaluationSignatoryAuthorityEmail(v) {
                this.onChangeEvaluationSignatoryAuthority(v);
            }, 
            selectedTrainingPlanSignatoryAuthorityEmail(v) {
            this.onChangetrainingPlanSignatoryAuthority(v);
            },
            selectedEmployerSignatoryAuthorityEmail(v){
            this.onChangeEmployerSignatoryAuthority(v);
            },
             proceedtoInitiate(val){
                debugger
                if(val && this.consentAvailable){
                    this.onInitiateClick();
                }
            }
        },
        computed: {
            ifSupervisor() {
                if(this.$route.name == 'supervisor-form-i983') {
                    return true
                }else {
                    return false
                }
            },
             _IsComplete()
            {
                if(!this.isupdate && !this.isSupervisor && this.triggerupdateapi)
                   return  true
            },
            _IsInitiate()
            {
               return this.isupdate == false && !this.triggerupdateapi
            },
            _IsUpadet()
            {
               return this.isupdate == true
            },
            _IsVerify()
            {
                if(this.isupdate == false && (this.isSupervisor))
                {
                    return true
                }
            },
            showEvalutionSummery()
            {
                if(this.$parent.$parent.isSupervisor || this.isSupervisor)
                {
                    if(this.isupdate || this.triggerupdateapi)
                    {
                        return true
                    }
                    else return false
                }
                else return true
            },
            EmployeeId() {
                return this.$parent.$parent.EmployeeId;
            },
            StudentName() {
                return this.$parent.$parent.StudentName;
            },
            IsFinalEvaluationDone() {
                return this.$parent.$parent.IsFinalEvaluationDone;
            },
            EnableSignPad()
            {
               return this.Evaluation.signatoryAuthority && this.loggedInUserObj.Email == this.Evaluation.signatoryAuthority.Email
            },
            IsSameEvaluationHRAndSignatoryAuthority() {
                if(this.loggedInUserObj.email ==  this.Evaluation.SignatoryAuthority.Email){
                    return true
                }else {
                    return false
                }
            },
        },
        created()
        {
           this.show = this.openModal
        },
         validations(){
                    return{
                        
                        selectedEvaluationSignatoryAuthorityEmail:{
                            required
                        },
                        selectedTrainingPlanSignatoryAuthorityEmail:{
                            requiredIf: requiredIf(() => {
                                if(this._IsInitiate && !this.IsInitiateOnlySectionType) {
                                    return true
                                }else {
                                    return false
                                }
                            }),
                        },
                        selectedEmployerSignatoryAuthorityEmail:{
                            requiredIf: requiredIf(() => {
                                if(this._IsInitiate && !this.IsInitiateOnlySectionType) {
                                    return true
                                }else {
                                    return false
                                }
                            }),
                        },
                        SupervisorSignatureDetails : {
                            Base64Url: {
                                requiredIf: requiredIf((a) => {
                                    if(this.previousData.SignatureType == 'Electronic' && !this._IsInitiate && this.ifSupervisor) {
                                        return true
                                    }else{
                                        return false
                                    }
                                })
                            },
                            tabType: {
                                requiredIf: requiredIf((a) => {
                                    if(this.previousData.SignatureType == 'Electronic' && !this._IsInitiate && this.ifSupervisor) {
                                        return true
                                    }else{
                                        return false
                                    }
                                })
                            }
                        },
                        SignatureType: {
                            requiredIf: requiredIf((a) => {
                                if(this._IsInitiate) {
                                    return true
                                }else {
                                    return false
                                }
                            })
                        },
                        Employer:{
                            "SignatoryAuthority":{
                                "Name": {
                                    requiredIf: requiredIf(() => {
                                        if(this._IsInitiate && !this.IsInitiateOnlySectionType) {
                                            return true
                                        }else {
                                            return false
                                        }
                                    }),
                                    maxLength: maxLength(150),
                                    letterCount
                                },
                                "Title": {
                                    requiredIf: requiredIf(() => {
                                        if(this._IsInitiate && !this.IsInitiateOnlySectionType) {
                                            return true
                                        }else {
                                            return false
                                        }
                                    }),
                                    maxLength: maxLength(150),
                                    letterCount
                                },
                                "Email": {
                                    requiredIf: requiredIf(() => {
                                        if(this._IsInitiate && !this.IsInitiateOnlySectionType) {
                                            return true
                                        }else {
                                            return false
                                        }
                                    }),
                                    email
                                },
                                "Phone":{
                                    requiredIf: requiredIf(() => {
                                        if(this._IsInitiate && !this.IsInitiateOnlySectionType) {
                                            return true
                                        }else {
                                            return false
                                        }
                                    }),
                                    phoneNumber,
                                    maxLength: maxLength(20),
                                    minLength: minLength(10)
                                },
                            }
                        },
                        AssignedTraining:{
                            "SignatoryAuthority":{
                                "Name": {
                                    requiredIf: requiredIf(() => {
                                        if(this._IsInitiate && !this.IsInitiateOnlySectionType) {
                                            return true
                                        }else {
                                            return false
                                        }
                                    }),
                                    maxLength: maxLength(150),
                                    letterCount
                                },
                                "Title": {
                                    requiredIf: requiredIf(() => {
                                        if(this._IsInitiate && !this.IsInitiateOnlySectionType) {
                                            return true
                                        }else {
                                            return false
                                        }
                                    }),
                                    maxLength: maxLength(150),
                                    letterCount
                                },
                                "Email": {

                                    requiredIf: requiredIf(() => {
                                        if(this._IsInitiate && !this.IsInitiateOnlySectionType) {
                                            return true
                                        }else {
                                            return false
                                        }
                                    }),
                                    email
                                },
                                "Phone":{
                                    requiredIf: requiredIf(() => {
                                        if(this._IsInitiate && !this.IsInitiateOnlySectionType) {
                                            return true
                                        }else {
                                            return false
                                        }
                                    }),
                                    phoneNumber,
                                    maxLength: maxLength(20),
                                    minLength: minLength(10)
                                },
                            }
                        },
                        Evaluation:{
                            "SignatoryAuthority":{
                            "Name": {
                                        required,
                                        maxLength: maxLength(150),
                                        letterCount
                                    },
                                        "Title": {
                                        required,
                                        maxLength: maxLength(150),
                                        letterCount
                                    },
                                        "Email": {
                                        required,
                                        email
                                    },
                                    "Phone":{
                                        required,
                                        phoneNumber,
                                        maxLength: maxLength(20),
                                        minLength: minLength(10)
                                    },
                                }
                        },
                        StudentDetails:{
                            "RangeOfEvaluationDateFrom":{
                                required
                            },
                            "RangeOfEvaluationDateTo":{
                                required
                            },
                            "Email": {
                                required,
                                email
                            },
                            "EvaluationSummary": {
                                requiredIf: requiredIf(() => this.showEvalutionSummery)
                            },
                        },   
                        SignatureDetails : {
                            Base64Url: {
                                requiredIf: requiredIf((a) => {
                                    if((this.previousData.SignatureType == 'Electronic' && this.previousData.Status == 'StudentEvaluationPending' && !this.ifSupervisor && !this._IsInitiate) || (this.previousData.SignatureType == 'Electronic' && this.isupdate && !this.ifSupervisor && !this._IsInitiate))  {
                                        return true
                                    }else{
                                        return false
                                    }
                                })
                            },
                        },
                    }
         },
        methods: {
            scrollToTop(val) {
                var a = document.getElementById('scrollable-container5')
                if(val) {
                    a.scroll({
                        top: 100, 
                        left: 0, 
                        behavior: 'smooth'
                    });
                }else {
                    a.scroll({
                        top: 100, 
                        left: 0, 
                        behavior: 'smooth'
                    });
                }
            },
            //signatory authority
            onChangeEvaluationSignatoryAuthority(selectedEvaluationSignatoryAuthorityEmail) {
                    if(selectedEvaluationSignatoryAuthorityEmail)
                    {
                         var index = this.signatoryauthorityList.data.findIndex(x => x.id == selectedEvaluationSignatoryAuthorityEmail);
                         if(index != -1) {
                            this.Evaluation.SignatoryAuthority.Name = this.signatoryauthorityList.data[index].text.replace(/\s?\(you\)\s*$/, '').trim();
                            this.Evaluation.SignatoryAuthority.Email = this.signatoryauthorityList.data[index].id,
                            this.Evaluation.SignatoryAuthority.Title = this.signatoryauthorityList.data[index].title,
                            this.Evaluation.SignatoryAuthority.Phone = this.signatoryauthorityList.data[index].phone,
                            this.Evaluation.SignatoryAuthority.Role = this.signatoryauthorityList.data[index].Role,
                            this.Evaluation.SignatoryAuthority.Id = this.signatoryauthorityList.data[index].SAId;

                         }
                    }

            },
            onChangetrainingPlanSignatoryAuthority(selectedEvaluationSignatoryAuthorityEmail){
              if (selectedEvaluationSignatoryAuthorityEmail) {
                  const selectedAuthority = this.signatoryauthorityList.data.find(x => x.id === selectedEvaluationSignatoryAuthorityEmail);
                    if (selectedAuthority) {
                      this.AssignedTraining.SignatoryAuthority.Name = selectedAuthority.text.replace(/\s?\(you\)\s*$/, '').trim();;
                      this.AssignedTraining.SignatoryAuthority.Email = selectedAuthority.id;
                      this.AssignedTraining.SignatoryAuthority.Title = selectedAuthority.title;
                      this.AssignedTraining.SignatoryAuthority.Phone = selectedAuthority.phone;
                      this.AssignedTraining.SignatoryAuthority.Role = selectedAuthority.Role;
                      this.AssignedTraining.SignatoryAuthority.Id = selectedAuthority.SAId;


                    }
              }
            },
            onChangeEmployerSignatoryAuthority(selectedEvaluationSignatoryAuthorityEmail){
              if (selectedEvaluationSignatoryAuthorityEmail) {
                  const selectedAuthority = this.signatoryauthorityList.data.find(x => x.id === selectedEvaluationSignatoryAuthorityEmail);
                    if (selectedAuthority) {
                      this.Employer.SignatoryAuthority.Name = selectedAuthority.text.replace(/\s?\(you\)\s*$/, '').trim();
                      this.Employer.SignatoryAuthority.Email = selectedAuthority.id;
                      this.Employer.SignatoryAuthority.Title = selectedAuthority.title;
                      this.Employer.SignatoryAuthority.Phone = selectedAuthority.phone;
                      this.Employer.SignatoryAuthority.Role = selectedAuthority.role;
                      this.Employer.SignatoryAuthority.Id = selectedAuthority.SAId;

                    }
              }
            },
            getSignatoryauthorityList()
            {
                // this.showSignatoryauthorityList = false
                ajax.get(`/I983/SignatoryList?employeeId=${this.previousData.Employee.EmployeeId}`,{},(res)=>{
                    this.signatoryauthorityList.data = __.map(res.data.SignatoryModelList, (t) => {
                        var name = t.BasicModel.Name;
                        if(t.Email == this.loggedInUserObj.email)
                        {
                          name = t.BasicModel.Name + "(you)";
                        }
                        return { 'id': t.Email, 'text': name, "title":t.Designation ,"Role":t.Role,"SAId":t.Id,"phone":t.Phone }
                    })
                    this.selectedEvaluationSignatoryAuthorityEmail = this.Evaluation.SignatoryAuthority.Email; // Ensure this is set correctly
                    this.showSignatoryauthorityList = true
                })
            },
            //signatory authority ends
            getLocation() {
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(position => {
                    this.location = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                        
                    };
                    if(this.location.latitude && this.location.longitude) {
                        const  url = `${c.APIBASEURL}/Google/GeoLocation?latitude=${this.location.latitude}&longitude=${this.location.longitude}`
                        ajax.get(url, {}, res => {
                            if(res.data.Status) {
                            const tempGeoLocation = res.data.GeoLocation
                            this.GeoLocation = `${tempGeoLocation.City}, ${tempGeoLocation.State}, ${tempGeoLocation.Country}`// var location = geoLocationResponse.City + "," + geoLocationResponse.State + "," + geoLocationResponse.Country
                            
                            }
                        })
                    }
                    }, error => {
                    console.error("Error getting user's location:", error);
                    });
                } else {
                    console.error("Geolocation is not supported by this browser.");
                }
            },
            handleCancel() {
                this.show = false;
                this.IsInitiateOnlySectionType = false,
                this.SignatureType = ''
                this.$v.SignatureType.$reset();
                this.SignatureDetails.SignatureURL=''
            this.SignatureDetails.EnableSignature=true
            this.SignatureDetails.IsNewSignature = true
            this.SignatureDetails.IsAllowEdit=true
            this.SignatureDetails.uploadData=''
            this.SignatureDetails.image=''
            this.SignatureDetails.tabType=''
            this.SignatureDetails.drawImage=''
            this.SignatureDetails.editUpload=false
            this.SignatureDetails.isDraw=false
            this.SignatureDetails.Base64Url=''
            this.SignatureDetails.metaInformation={}     
            },
            supervisorEditSignatureMethod(imgUrl,bool){
                // this.resetAttestation()
                if(imgUrl){
                    let specialchar = 'data:image/jpeg;base64';
                    this.SupervisorSignatureDetails.drawImage = '';
                    let regexPattern = new RegExp(`[${specialchar}]`, 'g');
                    let containsAllChars = specialchar.split('').every(char => imgUrl.match(regexPattern).includes(char));
                    if(containsAllChars) {
                        this.SupervisorSignatureDetails.drawImage = imgUrl
                    }else {
                        this.SupervisorSignatureDetails.drawImage = `data:image/jpeg;base64,${imgUrl}`
                    }
                    if(bool) {
                        var a = document.getElementById('scrollable-container5')
                        a.scroll({
                            top: 100, 
                            left: 0, 
                            behavior: 'smooth'
                        });
                    }
                // this.tabType = 'draw'
                this.openEditsignature =  true;
                this.SupervisorSignatureDetails.editUpload = true
                }
            },
            editSignatureMethod(imgUrl,bool){
                // this.resetAttestation()
                if(imgUrl){
                    let specialchar = 'data:image/jpeg;base64';
                    this.SignatureDetails.drawImage = '';
                    let regexPattern = new RegExp(`[${specialchar}]`, 'g');
                    let containsAllChars = specialchar.split('').every(char => imgUrl.match(regexPattern).includes(char));
                    if(containsAllChars) {
                        this.SignatureDetails.drawImage = imgUrl
                    }else {
                        this.SignatureDetails.drawImage = `data:image/jpeg;base64,${imgUrl}`
                    }
                    if(bool) {
                        var a = document.getElementById('scrollable-container5')
                        a.scroll({
                            top: 100, 
                            left: 0, 
                            behavior: 'smooth'
                        });
                    }
                // this.tabType = 'draw'
                this.openEditsignature =  true;
                this.SignatureDetails.editUpload = true
                }
            },
            SupervisorSignatureEdit(obj){
                let signdata = obj.type == 'Typed' && obj.href ? obj.href.split(',') : obj.type == 'Drawn' && obj.data ? obj.data.split(',') :  obj.type =='Uploaded' && obj.image ? obj.image.split(',') : [];
                let base64bitUrl = signdata && signdata.length > 0 ? signdata[signdata.length-1] : ''
                
                // this.EnableSignature = false
                this.SupervisorSignatureDetails.IsNewSignature = false
                this.SupervisorSignatureDetails.editUpload = false
                this.SupervisorSignatureDetails.uploadData = ""
                this.SupervisorSignatureDetails.image = ""
                this.SupervisorSignatureDetails.tabType = ""
                this.SupervisorSignatureDetails.drawImage = ""
                this.SupervisorSignatureDetails.metaInformation ={}
                // this.IsNewSignature = false
                
                if(obj.type == 'Typed'){
                    this.SupervisorSignatureDetails.IsNewSignature = true
                    this.SupervisorSignatureDetails.uploadData = obj.href
                    this.SupervisorSignatureDetails.image = obj.href
                    this.SupervisorSignatureDetails.SignatureURL = obj.href
                    this.SupervisorSignatureDetails.tabType = obj.type
                    this.SupervisorSignatureDetails.Base64Url = base64bitUrl
                    this.SupervisorSignatureDetails.isDraw = false
                    this.SupervisorSignatureDetails.metaInformation = obj.metaInformation
                    // this.IsNewSignature = true
                }
                if(obj.type == 'Uploaded'){
                    this.SupervisorSignatureDetails.editUpload = false
                    this.SupervisorSignatureDetails.uploadData = obj.data
                    this.SupervisorSignatureDetails.image = obj.image
                    this.SupervisorSignatureDetails.SignatureURL = obj.image
                    this.SupervisorSignatureDetails.tabType = obj.type
                    this.SupervisorSignatureDetails.Base64Url = base64bitUrl
                    this.SupervisorSignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    this.SupervisorSignatureDetails.IsNewSignature = true

                }
                if(obj.type == 'Drawn'){
                    this.SupervisorSignatureDetails.uploadData = obj.data
                    this.SupervisorSignatureDetails.image = obj.data
                    this.SupervisorSignatureDetails.SignatureURL = obj.data
                    // this.drawImage = obj.drawData
                    this.SupervisorSignatureDetails.tabType = obj.type
                    this.SupervisorSignatureDetails.Base64Url = base64bitUrl
                    this.SupervisorSignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    this.SupervisorSignatureDetails.IsNewSignature = true



                }
            },
            SignatureEdit(obj){
                let signdata = obj.type == 'Typed' && obj.href ? obj.href.split(',') : obj.type == 'Drawn' && obj.data ? obj.data.split(',') :  obj.type =='Uploaded' && obj.image ? obj.image.split(',') : [];
                let base64bitUrl = signdata && signdata.length > 0 ? signdata[signdata.length-1] : ''
                
                // this.EnableSignature = false
                this.SignatureDetails.IsNewSignature = false
                this.SignatureDetails.editUpload = false
                this.SignatureDetails.uploadData = ""
                this.SignatureDetails.image = ""
                this.SignatureDetails.tabType = ""
                this.SignatureDetails.drawImage = ""
                this.SignatureDetails.metaInformation ={}
                // this.IsNewSignature = false

                if(obj.type == 'Typed'){
                    this.SignatureDetails.uploadData = obj.href
                    this.SignatureDetails.image = obj.href
                    this.SignatureDetails.SignatureURL = obj.href
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = false
                    this.SignatureDetails.metaInformation = obj.metaInformation
                    // this.IsNewSignature = true
                    this.SupervisorSignatureDetails.IsNewSignature = true

                }
                if(obj.type == 'Uploaded'){
                    this.SignatureDetails.editUpload = false
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.image
                    this.SignatureDetails.SignatureURL = obj.image
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    this.SupervisorSignatureDetails.IsNewSignature = true

                }
                if(obj.type == 'Drawn'){
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.data
                    this.SignatureDetails.SignatureURL = obj.data
                    // this.drawImage = obj.drawData
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    this.SupervisorSignatureDetails.IsNewSignature = true



                }
            },
            SupervisorsaveSignature(obj) {
            let signdata = obj.type == 'Typed' && obj.href ? obj.href.split(',') : obj.type == 'Drawn' && obj.data ? obj.data.split(',') : obj.type =='Uploaded' && obj.image ? obj.image.split(',') : [];
                let base64bitUrl = signdata && signdata.length > 0 ? signdata[signdata.length-1] : ''
                
                // this.resetAttestation()
                this.SupervisorSignatureDetails.IsNewSignature = false
                this.SupervisorSignatureDetails.EnableSignature = true
                this.SupervisorSignatureDetails.uploadData = ""
                this.SupervisorSignatureDetails.image = ""
                this.SupervisorSignatureDetails.tabType = ""
                this.SupervisorSignatureDetails.drawImage = ""
                this.IsNewSignature = false
                this.SupervisorSignatureDetails.SignatureURL = ''

                if(obj.type == 'Typed'){
                    this.SupervisorSignatureDetails.EnableSignature = false
                    this.SupervisorSignatureDetails.uploadData = obj.href
                    this.SupervisorSignatureDetails.image = obj.href
                    this.SupervisorSignatureDetails.SignatureURL = obj.href
                    this.SupervisorSignatureDetails.tabType = obj.type
                    this.SupervisorSignatureDetails.Base64Url = base64bitUrl
                    this.SupervisorSignatureDetails.isDraw = false
                    this.SupervisorSignatureDetails.metaInformation = obj.metaInformation
                    // this.IsNewSignature = true
                    this.SupervisorSignatureDetails.IsNewSignature = true

                    // this.Section1.SignatureDetails.editUpload =true
                }
                if(obj.type == 'Uploaded'){
                    this.SupervisorSignatureDetails.EnableSignature = false
                    this.SupervisorSignatureDetails.uploadData = obj.data
                    this.SupervisorSignatureDetails.image = obj.image
                    this.SupervisorSignatureDetails.SignatureURL = obj.image
                    this.SupervisorSignatureDetails.tabType = obj.type
                    this.SupervisorSignatureDetails.Base64Url = base64bitUrl
                    this.SupervisorSignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    this.SupervisorSignatureDetails.IsNewSignature = true

                    // this.Section1.SignatureDetails.editUpload =true
                }
                if(obj.type == 'Drawn'){
                    this.SupervisorSignatureDetails.EnableSignature = false
                    this.SupervisorSignatureDetails.uploadData = obj.data
                    this.SupervisorSignatureDetails.image = obj.data
                    this.SupervisorSignatureDetails.SignatureURL = obj.data
                    // this.drawImage = obj.drawData
                    this.SupervisorSignatureDetails.tabType = obj.type
                    this.SupervisorSignatureDetails.Base64Url = base64bitUrl
                    this.SupervisorSignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    this.SupervisorSignatureDetails.IsNewSignature = true

                    // this.Section1.SignatureDetails.editUpload =true
                }
        },
        saveSignature(obj) {
            let signdata = obj.type == 'Typed' && obj.href ? obj.href.split(',') : obj.type == 'Drawn' && obj.data ? obj.data.split(',') : obj.type =='Uploaded' && obj.image ? obj.image.split(',') : [];
                let base64bitUrl = signdata && signdata.length > 0 ? signdata[signdata.length-1] : ''
                
                // this.resetAttestation()
                this.SignatureDetails.IsNewSignature = false
                this.SignatureDetails.EnableSignature = true
                this.SignatureDetails.uploadData = ""
                this.SignatureDetails.image = ""
                this.SignatureDetails.tabType = ""
                this.SignatureDetails.drawImage = ""
                this.IsNewSignature = false
                this.SignatureDetails.SignatureURL = ''

                if(obj.type == 'Typed'){
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.href
                    this.SignatureDetails.image = obj.href
                    this.SignatureDetails.SignatureURL = obj.href
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = false
                    this.SignatureDetails.metaInformation = obj.metaInformation
                    // this.IsNewSignature = true
                    this.SignatureDetails.IsNewSignature = true

                    // this.Section1.SignatureDetails.editUpload =true
                }
                if(obj.type == 'Uploaded'){
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.image
                    this.SignatureDetails.SignatureURL = obj.image
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    this.SignatureDetails.IsNewSignature = true

                    // this.Section1.SignatureDetails.editUpload =true
                }
                if(obj.type == 'Drawn'){
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.data
                    this.SignatureDetails.SignatureURL = obj.data
                    // this.drawImage = obj.drawData
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    this.SignatureDetails.IsNewSignature = true

                    // this.Section1.SignatureDetails.editUpload =true
                }
        },
        SupervisorDeleteSiganture(imgUrl){
                // this.resetAttestation()
                if(imgUrl){
                    this.SupervisorSignatureDetails.IsNewSignature = true
                    this.SupervisorSignatureDetails.EnableSignature = true
                    this.SupervisorSignatureDetails.image = ''
                    this.SupervisorSignatureDetails.Base64Url = ''
                    // this.$store.commit('updateWorkAuthorizationValue', { field: 'signature', value: '' })
                }
            },
        deleteSiganture(imgUrl){
                // this.resetAttestation()
                if(imgUrl){
                    this.SignatureDetails.IsNewSignature = true
                    this.SignatureDetails.EnableSignature = true
                    this.SignatureDetails.image = ''
                    this.SignatureDetails.Base64Url = ''
                    // this.$store.commit('updateWorkAuthorizationValue', { field: 'signature', value: '' })
                }
            },
            resetData() {



                this.StudentDetails={
                    EmployeeId:'',
                    Name:'',
                    EmailAddress:'',
                    
                    RangeOfEvaluationDateFrom:'',
                    RangeOfEvaluationDateTo:'',
                    isFinalEvalution:'',
                    EvaluationSummary: '',
                    Email:'',
                    Title: '',
                    SignatoryAuthority: {
                    SiteName: '',
                    SiteAddress: '',
                    
                    }
                 }
                
                this.EmployerDetails = {
                    Signatoryauthority: {
                        Name: '',
                        Email: '',
                        Title: '',
                        Phone: '',
                        Role:''
                    },
                };

                this.$v.StudentDetails.$reset();
                this.$v.SignatureDetails.$reset();
                this.$v.SupervisorSignatureDetails.$reset();


            },
          copyFromStore() { 
            
            this.Evaluation.SignatoryAuthority.Name = this.previousData.Evaluation.SignatoryAuthority.Name ? (this.previousData.Evaluation.SignatoryAuthority.Name.includes("(you)") ? this.previousData.Evaluation.SignatoryAuthority.Name.replace("(you)", "").trim() : this.previousData.Evaluation.SignatoryAuthority.Name) : this.previousData.Evaluation.SignatoryAuthority.Name;
            this.Evaluation.SignatoryAuthority.Email = this.previousData.Evaluation.SignatoryAuthority.Email;
            this.Evaluation.SignatoryAuthority.Title = this.previousData.Evaluation.SignatoryAuthority.Title;
            this.Evaluation.SignatoryAuthority.Phone = this.previousData.Evaluation.SignatoryAuthority.Phone;
            this.Evaluation.SignatoryAuthority.Role = this.previousData.Evaluation.SignatoryAuthority.Role;
            this.selectedEvaluationSignatoryAuthorityEmail = this.previousData.Evaluation.SignatoryAuthority.Email;

            this.Employer.SignatoryAuthority.Name = this.previousData.Employer.SignatoryAuthority.Name ? (this.previousData.Employer.SignatoryAuthority.Name.includes("(you)") ? this.previousData.Employer.SignatoryAuthority.Name.replace("(you)", "").trim() : this.previousData.Employer.SignatoryAuthority.Name) : this.previousData.Employer.SignatoryAuthority.Name;
            this.Employer.SignatoryAuthority.Email = this.previousData.Employer.SignatoryAuthority.Email;
            this.Employer.SignatoryAuthority.Title = this.previousData.Employer.SignatoryAuthority.Title;
            this.Employer.SignatoryAuthority.Phone = this.previousData.Employer.SignatoryAuthority.Phone;
            this.selectedEmployerSignatoryAuthorityEmail = this.previousData.Employer.SignatoryAuthority.Email;

            this.AssignedTraining.SignatoryAuthority.Name = this.previousData.AssignedTraining.SignatoryAuthority.Name ? (this.previousData.AssignedTraining.SignatoryAuthority.Name.includes("(you)") ? this.previousData.AssignedTraining.SignatoryAuthority.Name.replace("(you)", "").trim() : this.previousData.AssignedTraining.SignatoryAuthority.Name) : this.previousData.AssignedTraining.SignatoryAuthority.Name;
            this.AssignedTraining.SignatoryAuthority.Email = this.previousData.AssignedTraining.SignatoryAuthority.Email;
            this.AssignedTraining.SignatoryAuthority.Title = this.previousData.AssignedTraining.SignatoryAuthority.Title;
            this.AssignedTraining.SignatoryAuthority.Phone = this.previousData.AssignedTraining.SignatoryAuthority.Phone;
            this.selectedTrainingPlanSignatoryAuthorityEmail = this.previousData.AssignedTraining.SignatoryAuthority.Email;
            
            this.StudentDetails.Name = this.previousData.Employee.Name;
            this.StudentDetails.EmailAddress = this.previousData.Employee.Email;
            this.StudentDetails.EmployeeId = this.previousData.Employee.EmployeeId;
            // this.SignatureDetails.SignatureURL = this.previousData.Evaluation.Base64EncodedSignature
            if(this.ifSupervisor) {
                  this.SignatureDetails.SignedDate = this.previousData.Evaluation.SignedDate
                  this.SupervisorSignatureDetails.SignatureURL = this.previousData.Evaluation.SignatureURL
                  this.SupervisorSignatureDetails.Base64Url = this.previousData.Evaluation.Base64EncodedSignature
                  this.SupervisorSignatureDetails.EnableSignature = this.previousData.Evaluation.SignatureURL && this.previousData.Evaluation.SignatureURL != '' ? false : true,
                  this.SupervisorSignatureDetails.tabType = this.previousData.Evaluation.SigningType
                  this.SupervisorSignatureDetails.image = this.previousData.Evaluation.Base64EncodedSignature
            }
            this.SignatureDetails.SignedDate = this.previousData.Evaluation.EmployeeSignedDate
            this.SignatureDetails.SignatureURL = this.previousData.Evaluation.EmployeeSignatureURL
            this.SignatureDetails.Base64Url = this.previousData.Evaluation.EmployeeBase64EncodedSignature
            this.SignatureDetails.EnableSignature = this.previousData.Evaluation.EmployeeSignatureURL && this.previousData.Evaluation.EmployeeSignatureURL != '' ? false : true,
            this.SignatureDetails.tabType = this.previousData.Evaluation.EmployeeSigningType
            this.SignatureDetails.image = this.previousData.Evaluation.EmployeeBase64EncodedSignature         

                

            if(this.triggerupdateapi === true || this.isupdate) {
                this.StudentDetails.EvaluationSummary = this.previousData.Evaluation.EvaluationSummary;
                this.StudentDetails.RangeOfEvaluationDateFrom = this.previousData.Evaluation.EvaluationFrom != 'N/A' ? this.previousData.Evaluation.EvaluationFrom : '';
                this.StudentDetails.RangeOfEvaluationDateTo = this.previousData.Evaluation.EvaluationTo != 'N/A' ? this.previousData.Evaluation.EvaluationTo : '';
                this.StudentDetails.isFinalEvalution = this.previousData.Evaluation.IsFinalEvalution;
            }

            this.disableFinalEvaluationCheckbox = this.IsFinalEvaluationDone && this.StudentDetails.isFinalEvalution == false;

             this.IsInitiateOnlySectionType = true;
        },
        copyToStore() {

            let obj = {
                Evaluation: {}
            };

            obj.Evaluation.EvaluationFrom = this.StudentDetails.RangeOfEvaluationDateFrom;
            obj.Evaluation.EvaluationTo = this.StudentDetails.RangeOfEvaluationDateTo;
            obj.Evaluation.EvaluationSummary = this.StudentDetails.EvaluationSummary;
            obj.Evaluation.IsFinalEvalution = this.StudentDetails.isFinalEvalution;
            obj.Evaluation.IsSupervisorVerified = this.previousData.Evaluation.IsSupervisorVerified
            if(this.ifSupervisor) {

                // obj.Evaluation.SignatureURL = this.SupervisorSignatureDetails.SignatureURL

                  obj.Evaluation.SignedDate = this.SupervisorSignatureDetails.SignedDate
                  obj.Evaluation.Base64EncodedSignature = this.SupervisorSignatureDetails.Base64Url 
               //    obj.Evaluation.EnableSignature  = this.SignatureDetails.SignatureURL
                  obj.Evaluation.SigningType = this.SupervisorSignatureDetails.tabType 
                  obj.Evaluation.SignatureURL = this.SupervisorSignatureDetails.image 
                }else {
                // obj.Evaluation.EmployeeSignatureURL = this.SignatureDetails.SignatureURL 
                obj.Evaluation.EmployeeSignedDate = this.SignatureDetails.SignedDate
                  obj.Evaluation.EmployeeBase64EncodedSignature = this.SignatureDetails.Base64Url 
               //    obj.Evaluation.EnableSignature  = this.SignatureDetails.SignatureURL
                  obj.Evaluation.EmployeeSigningType = this.SignatureDetails.tabType 
                  obj.Evaluation.EmployeeSignatureURL = this.SignatureDetails.image 

            }
            
            if(this.isSupervisor)
            {
               obj.Evaluation.IsSupervisorVerified = true
            }
            this.$emit('update:previousData', obj);
        },
          onFromDateChange(e) {
                    this.$refs.dateTo.data.minDate(e.date)
           },
          onInitiateClick()
          {
          
            this.$v.StudentDetails.$touch();
            this.$v.Evaluation.$touch(); 
            this.$v.Employer.$touch();
            this.$v.AssignedTraining.$touch();               
            this.$v.SignatureDetails.$touch();
            this.$v.SupervisorSignatureDetails.$touch();
            this.$v.SignatureType.$touch();
            this.$v.selectedEvaluationSignatoryAuthorityEmail.$touch()
            this.$v.selectedEmployerSignatoryAuthorityEmail.$touch();
            this.$v.selectedTrainingPlanSignatoryAuthorityEmail.$touch();
            
              if(this.$v.Evaluation.SignatoryAuthority.$invalid  == false && !this.$v.SignatureDetails.$invalid && !this.$v.SupervisorSignatureDetails.$invalid && !this.$v.SignatureType.$invalid && !this.$v.Employer.SignatoryAuthority.$invalid &&!this.$v.AssignedTraining.SignatoryAuthority.$invalid && !this.$v.selectedEvaluationSignatoryAuthorityEmail.$invalid && !this.$v.selectedEmployerSignatoryAuthorityEmail.$invalid && !this.$v.selectedTrainingPlanSignatoryAuthorityEmail.$invalid && !this.$v.StudentDetails.RangeOfEvaluationDateFrom.$invalid && !this.$v.StudentDetails.RangeOfEvaluationDateTo.$invalid && !this.$v.StudentDetails.EvaluationSummary.$invalid)
              {
                if(this.ifSupervisor) {

                    var evaluation = {
                         EvaluationFrom : this.StudentDetails.RangeOfEvaluationDateFrom,
                         EvaluationTo : this.StudentDetails.RangeOfEvaluationDateTo,
                         EvaluationSummary : this.StudentDetails.EvaluationSummary,
                         IsFinalEvalution : this.StudentDetails.isFinalEvalution,
                         IsSupervisorVerified: this.isSupervisor ? true : this.previousData.Evaluation.IsSupervisorVerified,
                         SignedDate: this.SupervisorSignatureDetails.SignedDate,
                         Base64EncodedSignature: this.SupervisorSignatureDetails.Base64Url,
                         SigningType:this.SupervisorSignatureDetails.tabType,
                         SignatoryAuthority:this.Evaluation.SignatoryAuthority
                    }
                }else {

                    var evaluation = {
                         EvaluationFrom : this.StudentDetails.RangeOfEvaluationDateFrom,
                         EvaluationTo : this.StudentDetails.RangeOfEvaluationDateTo,
                         EvaluationSummary : this.StudentDetails.EvaluationSummary,
                         IsFinalEvalution : this.StudentDetails.isFinalEvalution,
                         IsSupervisorVerified: this.isSupervisor ? true : this.previousData.Evaluation.IsSupervisorVerified,
                         EmployeeSignedDate: moment(new Date()).format("MM/DD/YYYY"),
                         EmployeeBase64EncodedSignature: this.SignatureDetails.Base64Url,
                         EmployeeSigningType:this.SignatureDetails.tabType,
                         SignatoryAuthority:this.Evaluation.SignatoryAuthority
                    }
                }

                  var employee = {
                      EmployeeId : !this.$parent.$parent.isSupervisor ? this.EmployeeId : this.$parent.$parent.EmployeeId ,
                      Name: this.StudentDetails.Name,                       

                 }
                 var signatoryAuthority = {
                    Name : this.Evaluation.SignatoryAuthority.Name && this.Evaluation.SignatoryAuthority.Name.includes("(you)") ? this.Evaluation.SignatoryAuthority.Name.replace("(you)", "").trim() : this.Evaluation.SignatoryAuthority.Name,
                    Email :  this.Evaluation.SignatoryAuthority.Email,
                    Title :  this.Evaluation.SignatoryAuthority.Title == 'HRManager' ? 'HR Manager': this.Evaluation.SignatoryAuthority.Title,
                    Phone: this.Evaluation.SignatoryAuthority.Phone,
                    Role:this.Evaluation.SignatoryAuthority.Role,
                    Id:this.Evaluation.SignatoryAuthority.Id

                 }
                 var TrainingsignatoryAuthority ={
                    Name : this.AssignedTraining.SignatoryAuthority.Name && this.AssignedTraining.SignatoryAuthority.Name.includes("(you)") ? this.AssignedTraining.SignatoryAuthority.Name.replace("(you)", "").trim() : this.AssignedTraining.SignatoryAuthority.Name,
                    Email :  this.AssignedTraining.SignatoryAuthority.Email,
                    Title :  this.AssignedTraining.SignatoryAuthority.Title == 'HRManager' ? 'HR Manager': this.AssignedTraining.SignatoryAuthority.Title,
                    Phone : this.AssignedTraining.SignatoryAuthority.Phone,
                    Role : this.AssignedTraining.SignatoryAuthority.Role,
                    Id : this.AssignedTraining.SignatoryAuthority.Id
                 }
                 var TrainingNewsignatoryAuthority ={
                    Name : this.Employer.SignatoryAuthority.Name && this.Employer.SignatoryAuthority.Name.includes("(you)") ? this.Employer.SignatoryAuthority.Name.replace("(you)", "").trim() : this.Employer.SignatoryAuthority.Name,
                    Email :  this.Employer.SignatoryAuthority.Email,
                    Title :  this.Employer.SignatoryAuthority.Title == 'HRManager' ? 'HR Manager': this.Employer.SignatoryAuthority.Title,
                    Phone : this.Employer.SignatoryAuthority.Phone,
                    Role : this.Employer.SignatoryAuthority.Role,
                    Id : this.Employer.SignatoryAuthority.Id
                 }
                 var employer = {
                    SignatoryAuthority : TrainingNewsignatoryAuthority
                 }
                 this.EvalutionObj =
                  {
                       AssignedTraining:{
                        SignatoryAuthority:TrainingsignatoryAuthority,
                        // SignatoryAuthority:TrainingNewsignatoryAuthority
                       },
                       Evaluation : evaluation,
                       Employee : employee,
                       Employer : employer,
                       Type :  "Evaluation",
                       IsInitiateOnlySectionType:this.IsInitiateOnlySectionType,
                        SignatureType: this.SignatureType,
                        // GeoLocation: this.SignatureDetails.IsNewSignature ? this.GeoLocation : null,
                        GeoLocation: (this.SignatureDetails.IsNewSignature && !this.ifSupervisor)  ? 'SignatureSigned' : 'SupervisorSignatureSigned',
                        UserAgent:navigator.userAgent,
                       // SignatoryAuthority:TrainingNewsignatoryAuthority
                  }

                  if(this.isSupervisor)
                  {
                      this.makeUpdateAPICall();
                  }
                  else if(this.triggerupdateapi === true) {
                      if(this.isupdate) {
                        this.makeUpdateAPICall();
                      } else {
                        this.$loading({'loadingText': 'Previewing Student Evaluation...'});
                        this.$parent.previewDocument("Evaluation", this.EvalutionObj);
                      }
                  } else {
                      this.makeInitiateAPICall();
                  }
                  this.proceedtoInitiate =false
            }
          },
          makeInitiateAPICall() {
              this.$loading({'loadingText': 'Initiating Student Evaluation...'});
                ajax.post(`/I983/Initiate?empOrgId=${loggedInUserObj.orgId}`,this.EvalutionObj, (res) => {
                  if(res.data.State == true) {
                      this.$message({
                          type: 'success',
                          message: 'Student Evaluation initiated successfully'
                      });
                       this.$loading({}).close()
                       this.show = false;
                       this.$emit('initiated');
                       window.bus.fire('SendI983RefreshSignal', 'fromSignaR');
                  }else if(res.data.State == false){
                      this.$loading({}).close()
                       this.show = false
                       this.ESSEnableDisable(res)
                      this.$message({
                          type: 'error',
                          message: res.data.Message
                      });
                  }
              });
            },
            makeUpdateAPICall() {
                if(this.isSupervisor)
                {
                     if(this.isupdate) {
                         this.$loading({'loadingText': 'Updating Student Evaluation...'});
                      }
                      else{
                      this.$loading({'loadingText': 'Verifying Student Evaluation...'});
                      }
                }
               else if(this.isupdate) {
                    this.$loading({'loadingText': 'Updating Student Evaluation...'});
                } else {  // Student click the 'Initiate' button
                    this.$loading({'loadingText': 'Initiating Student Evaluation...'});
                }

                ajax.put(`/I983/${this.previousData.Id}/UpdateStudentEvalution`,this.EvalutionObj, (res) => {
                    if(res.data.State == true) {
                        if(this.isSupervisor)
                        {
                            this.$message({
                                type: 'success',
                                message: 'Student Evaluation verified successfully'
                            });
                        }
                       else if(this.isupdate) {
                            this.$message({
                                type: 'success',
                                message: 'Student Evaluation updated successfully'
                            });
                        } else {  // Student click the 'Initiate' button
                            this.$message({
                                type: 'success',
                                message: 'Student Evaluation initiated successfully'
                            });
                        }
                        this.$loading({}).close();
                        this.copyToStore();
                        this.$parent.$parent.insertModifiedLogToStore('Evaluation');
                         this.show = false;
                         window.bus.fire('SendI983RefreshSignal', 'fromSignaR');
                    } else if(res.data.State == false) {
                        this.$loading({}).close()
                        this.show = false
                        this.ESSEnableDisable(res)
                        this.$message({
                            type: 'error',
                            message: res.data.Message
                        });
                    }
                });
            },
            showElectronicsign(){
                debugger
            this.showElectronicSignPopUp = true;
            }
        }
    }
</script>
<style lang="scss" scoped>
   .title-content
   {
       color: #4a90e2;
       font-size: 14px;
   }
   .rowgap
   {
       margin-top: 10px;
   }
   .validation-star{
            color: #F31D1D;
    }
    .radio-inline
    {
        padding-left: 0px
    }
    label{

         color :#a4abb9
    }
    .preview-details {
		padding: 10px 0;
	}
     .img_design{
        width: 15px;
        border-radius: 25%;
        margin-left: 6px;
    }
    .edit-sign-icon {
        height: 35px;
        width: 35px;
        cursor: pointer;
        margin-bottom: 20px;
    }
    .delete-sign-icon {
        height: 35px;
        width: 35px; 
        margin-bottom: -65px;
        cursor: pointer;
    }
    .custom-sign-div {
        flex: 1 1 auto;
        min-height: 1px;
        /* padding: 1.5rem; */
        background: #FCFCFF;
        text-align: center;
        border: 1px solid rgba(219,219,232,0.50);
        width: 650px;
        height:139px !important;
        padding: 20px 15px;
    }
    .custom-sign-div_inline_style1{
        display:inline-block;
        height:100px;
        width:49%;
        float:left; 
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/InitiateStudentEvalution.vue